import { Button as MuiButton } from '@mui/material';
import type { ButtonProps as MuiButtonProps } from '@mui/material/Button';

export type ButtonProps = MuiButtonProps;

export const Button = ({ children, ...props }: Readonly<ButtonProps>) => (
  <MuiButton {...props}>{children}</MuiButton>
);
